import { ReactNode } from "react";

const SectionCard = ({
  icon,
  title,
  description,
  children,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  children: ReactNode;
}) => (
  <div
    style={{
      background: "#fff",
      border: "1px solid #e4e7ec",
      borderRadius: 12,
      overflow: "hidden",
      marginBottom: 20,
    }}
  >
    <div
      style={{
        padding: "12px 20px",
        borderBottom: "1px solid #e4e7ec",
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "#fafafa",
      }}
    >
      {icon && (
        <span style={{ color: "#6b7280", display: "flex", alignItems: "center" }}>
          {icon}
        </span>
      )}
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#111827", lineHeight: 1.4 }}>
          {title}
        </div>
        {description && (
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
            {description}
          </div>
        )}
      </div>
    </div>
    <div style={{ padding: "16px 20px" }}>{children}</div>
  </div>
);

export default SectionCard;
